'use strict';

const {datadogRum} = require('@datadog/browser-rum');

const DataDogRum = {
    init: function () {
        if (SitePreferences.DATA_DOG_CONFIG) {
            const {
                dataDogApplicationID,
                dataDogClientToken,
                dataDogSessionReplaySampleRate,
                dataDogSessionSampleRate,
                dataDogSite,
                dataDogService,
                dataDogEnvironment,
            } = SitePreferences.DATA_DOG_CONFIG;

            datadogRum.init({
                applicationId: dataDogApplicationID,
                clientToken: dataDogClientToken,
                site: dataDogSite,
                service: dataDogService,
                env: dataDogEnvironment,
                sessionSampleRate: dataDogSessionSampleRate || 100,
                sessionReplaySampleRate: dataDogSessionReplaySampleRate || 100,
                trackBfcacheViews: true,
                defaultPrivacyLevel: 'mask'
            });
        } else {
            console.warn('Datadog RUM is not initialized. Missing configuration in SitePreferences.');
        }
    },
};

module.exports = DataDogRum;
